import React from "react";
import { THEME_COLORS } from "../../themes/DarkLight";
import useThemeHook from "../../hooks/useThemeHook";
import SectionTitle from "../../components/SectionTitle";
import CommonPageTitle from "../../components/CommonPageTitle";
import Text from "../../components/ThemedText";
import { FONTSIZE } from "../../../constants";

const dapps = [
  {
    id: 0,
    name: "Orbit",
    category: "Consumer Business",
    icon: "╚",
    link: "https://tryorbit.web.app",
  },
  {
    id: 1,
    name: "Pi Wallet",
    category: "DeFi",
    icon: "💰",
    link: "https://wallet.pinet.com/",
  },
  {
    id: 2,
    name: "Brainstorm",
    category: "Defi",
    icon: "📊",
    link: "https://brainstorm.pinet.com",
  },
  {
    id: 3,
    name: "Mine Pi",
    category: "Defi",
    icon: "⛏️",
    link: "https://minepi.com/",
  },
  {
    id: 4,
    name: "DreamWorld",
    category: "AI",
    icon: "🏪",
    link: "https://dreamworldapp.web.app/",
  },
  {
    id: 5,
    name: "FundFlow",
    category: "Crowdfuncding",
    icon: "💸",
    link: "https://fundflow0x.web.app",
  },
  {
    id: 6,
    name: "Pi Profiles",
    category: "DeFi",
    icon: "🖼️",
    link: "https://profiles.pinet.com",
  },
  {
    id: 7,
    name: "Pichainmall",
    category: "Marketplace",
    icon: "🏪",
    link: "https://pipcm.com/",
  },
];

const mustCheck = dapps.slice(0, 3);
const mostPopular = dapps.slice(3, 7);

const DappItem = ({ dapp }: { dapp: any }) => {
  const theme = useThemeHook();

  const handleDappClick = () => {
    window.open(dapp.link, "_blank");
  };

  return (
    <div
      style={{
        backgroundColor: THEME_COLORS[theme].component_background_color,
        borderRadius: "12px",
        padding: "20px",
        display: "flex",
        alignItems: "center",
        marginBottom: "0px",
        transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
        cursor: "pointer",
      }}
      onClick={handleDappClick}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-5px)";
        e.currentTarget.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.15)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 4px 6px rgba(0, 0, 0, 0.1)";
      }}
    >
      <div style={{ marginRight: "15px" }}>{dapp.icon}</div>
      <div>
        <Text
          style={{ fontSize: FONTSIZE.TERTIARY, fontWeight: "500" }}
          text={dapp.name}
        />
        <Text style={{ fontSize: FONTSIZE.QUATERNARY }} text={dapp.category} />
      </div>
    </div>
  );
};

const DappSection = ({ title, dapps }: { title: any; dapps: any }) => (
  <div style={{ marginBottom: "20px" }}>
    <SectionTitle text={title} />
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
        gap: "5px",
      }}
    >
      {dapps.map((dapp: any) => (
        <DappItem key={dapp.id} dapp={dapp} />
      ))}
    </div>
  </div>
);

const ExplorerPage = () => {
  const theme = useThemeHook();

  return (
    <div
      style={{
        padding: "13px",
        overflowY: "scroll",
        backgroundColor: THEME_COLORS[theme].page_background_color,
      }}
    >
      <CommonPageTitle padding={0} title="Dapps Explorer" />
      <DappSection title="Must Check" dapps={mustCheck} />
      <DappSection title="Most Popular" dapps={mostPopular} />
      <DappSection title="All Dapps" dapps={dapps} />
      <div style={{ height: "100px" }}></div>
    </div>
  );
};

export default ExplorerPage;
